import React, { Component } from "react";
import '../assets/css/question.css';
import '../assets/css/custom.css';
import '../assets/css/new_style.css';
import CheifComplain from './CheifComplain';
import CheifComplainLocation from './CheifComplainLocation';
import Profile from './Profile';
import Questions from "./Questions";
import PatientNarrative from "./PatientNarrative";
import PatientResponse from "./PatientResponse";

import { CONFIG,checkAuth,getLoggedInData ,decryptPHI} from '../helpers/Common';
import IdleTimer from 'react-idle-timer'

class Master extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            next:1,
            prev:0,
            profileData:'',
            complainData:'',
            complainLocation:'',
            questionAnswersData: [],
            responseData: '',
            narrativeSummary: '',
            checkedItems: new Map(),
            isNarrativeUpdate: false,
            surgeon_id: '',
            optionInputFields:new Array(),
            showInput:'',
            selectedComplains: new Array(),
            addAnotherComplain:false,
            allComplains:[],
            isModify:false,
            allQuestions:[],
            narrativeData:[],
            complainStack:[],
            removedFromStack:[]
        };
        this.handleNextPrevSteps        = this.handleNextPrevSteps.bind(this)
        this.setProfileData             = this.setProfileData.bind(this)
        this.setComplainData            = this.setComplainData.bind(this)
        this.setComplainLocationData    = this.setComplainLocationData.bind(this)
        this.setResponseData            = this.setResponseData.bind(this)
        this.setNarrativeSummary        = this.setNarrativeSummary.bind(this)
        this.setAllComplains            = this.setAllComplains.bind(this)
        this.setCheckedItems            = this.setCheckedItems.bind(this)
        this.setIsNarrativeUpdate       = this.setIsNarrativeUpdate.bind(this)
        this.setSelectedComplains       = this.setSelectedComplains.bind(this)
        this.setAllQuestions            = this.setAllQuestions.bind(this)
        this.setIsModify                = this.setIsModify.bind(this);
        this.setNarrativeData           =this.setNarrativeData.bind(this);
        this.setComplainStack           =this.setComplainStack.bind(this);
        this.checkAuth                  = checkAuth();//
        this.getLoggedInData            = getLoggedInData();//
        this.idleTimer = null
        this.onIdle = this._onIdle.bind(this)
    }
    componentWillMount() {
        checkAuth();
        let _data = getLoggedInData()
        let patientPrevData = localStorage.getItem('patientProfile');
        if(patientPrevData)
        {
            this.handleNextPrevSteps(2);
        }
        
        
        this.setState({
            surgeon_id: _data.user_id,
        });
        
        
    }

    setComplainStack = (complainType,msg)=>{
        console.log('complainType  in master, ',complainType);
        console.log('state selectedComplains  in master, ',this.state.selectedComplains);
        var complainStackVar =  this.state.complainStack;
        var removedStackVar  =  this.state.removedFromStack;
        
        if (msg == 'update') 
        {
            console.log('removedStackVar',removedStackVar);
            
            if (!removedStackVar.includes(complainType)) {
                if (!this.state.selectedComplains.includes(complainType)) 
                {
                    complainStackVar.push(complainType);
                    let unique = [...new Set(complainStackVar)];
                    this.setState({
                        complainStack:unique
                    })
                }
                
            } 
            
        } else {
         
            var removeItem = complainStackVar.shift();
            console.log('complainStackVar',complainStackVar);
            
            removedStackVar.push(removeItem);

            this.setState({
                removedFromStack :removedStackVar,
                complainStack:complainStackVar
           })
        }
        console.log('Complain stack in master, ',this.state.complainStack);
        
    }
    setAllQuestions=(questions)=>{

        this.setState({
             allQuestions:questions
        })

    };

    setNarrativeData=(data)=>{

        this.setState({narrativeData:data});
    };

    setIsModify=(isTrue)=>{

        this.setState({
            isModify:isTrue
        })
    };
    
    //Clear local storage on close and timeout
    _onIdle(e) {
        localStorage.removeItem('data');
        localStorage.removeItem('patientProfile');
        window.location.reload();
    }
    componentDidMount() {
        window.addEventListener("beforeunload", (ev) => {
            ev.preventDefault();
            localStorage.removeItem('data');
            localStorage.removeItem('patientProfile');
            window.location.reload();
        });
    }

    render() {
        return (
            <React.Fragment>
                {/* <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onIdle={this.onIdle}
                    debounce={250}
                    timeout={1000 * 60 * CONFIG.IdleTimeOut} /> */}

                {this.state.next === 1 && 
                    <Profile 
                        setProfileData={this.setProfileData} 
                        handleNextPrevSteps={this.handleNextPrevSteps} 
                    />
                }
                {this.state.next === 2 && 
                    <CheifComplain 
                        next={this.state.next} 
                        prev={this.state.prev} 
                        handleNextPrevSteps={this.handleNextPrevSteps} 
                        getComplainData={this.state.complainData} 
                        profileData={this.state.profileData} 
                        setComplainLocation={this.setComplainLocationData} 
                        setComplainData={this.setComplainData}
                        getSelectedComplains={this.state.selectedComplains}
                        addAnotherComplain={this.state.addAnotherComplain}
                        setIsModify={this.setIsModify}
                        isModify={this.state.isModify}
                        setSelectedComplains={this.setSelectedComplains}
                        complainStack = {this.state.complainStack}
                    />
                }
                {this.state.next === 3 && this.state.complainData!=='' && this.state.complainData.complainTypeDetails.image_front !== '' &&
                    <CheifComplainLocation 
                        next={this.state.next} 
                        prev={this.state.prev} 
                        handleNextPrev={this.handleNextPrevSteps}  
                        getComplainData={this.state.complainData} 
                        setComplainLocation={this.setComplainLocationData}
                        getComplainLocationData={this.state.complainLocationData} 
                    />
                }

                {this.state.next === 3 && this.state.complainData!=='' && this.state.complainData.complainTypeDetails.image_front === '' &&
                <Questions
                    next={this.state.next}
                    prev={this.state.prev}
                    handleNextPrevSteps={this.handleNextPrevSteps}
                    handleNextPrevSteps={this.handleNextPrevSteps}
                    getComplainData={this.state.complainData}
                    setQuestionAnswersData={this.setQuestionAnswersData}
                    setCheckedItems={this.setCheckedItems}
                    checkedItems={this.state.checkedItems}
                    questionAnswersData={this.state.questionAnswersData}
                    isNarrativeUpdate={this.state.isNarrativeUpdate}
                    optionInputFields={this.state.optionInputFields}
                    showInput={this.state.showInput}
                    setOptionInputFields={this.setOptionInputFields}
                    setInputField={this.setShowInputField}
                    getProfileData={this.state.profileData}
                    setComplainLocation={this.setComplainLocationData}
                    narrativeData={this.state.narrativeData}
                    setNarrativeData={this.setNarrativeData}
                    isModify={this.state.isModify}
                    setComplainStack={this.setComplainStack}
                    getComplainStack={this.state.complainStack}
                    setSelectedComplains={this.setSelectedComplains}
                    setIsModify={this.setIsModify}
                    addAnotherComplain={this.addAnotherComplain}

                    getProfileData={this.state.profileData} 
                    getQuestionAnswersData={this.state.questionAnswersData} 
                    getAllComplains={this.state.allComplains}
                    getComplainData={this.state.complainData} 
                    getComplainLocationData={this.state.complainLocationData} 
                    surgeon_id={this.state.surgeon_id}
                    setAllComplains={this.setAllComplains}
                    setNarrativeSummary={this.setNarrativeSummary}
                    


                />

                }

                {this.state.next === 4 && 
                    <Questions 
                        next={this.state.next} 
                        prev={this.state.prev} 
                        handleNextPrevSteps={this.handleNextPrevSteps} 
                        getComplainData={this.state.complainData}  
                        setQuestionAnswersData={this.setQuestionAnswersData} 
                        setCheckedItems={this.setCheckedItems} 
                        checkedItems={this.state.checkedItems} 
                        questionAnswersData={this.state.questionAnswersData}
                        isNarrativeUpdate={this.state.isNarrativeUpdate}
                        optionInputFields={this.state.optionInputFields}
                        showInput={this.state.showInput}
                        setOptionInputFields={this.setOptionInputFields}
                        setInputField={this.setShowInputField}
                        getProfileData={this.state.profileData}
                        setAllQuestions={this.setAllQuestions}
                        getAllQuestions={this.state.allQuestions}
                        setComplainLocation={this.setComplainLocationData}
                        narrativeData={this.state.narrativeData}
                        setNarrativeData={this.setNarrativeData}
                        isModify={this.state.isModify}
                        setComplainStack={this.setComplainStack}
                        getComplainStack={this.state.complainStack}
                        setSelectedComplains={this.setSelectedComplains}
                        setIsModify={this.setIsModify}
                        addAnotherComplain={this.addAnotherComplain}

                        getProfileData={this.state.profileData} 
                        getQuestionAnswersData={this.state.questionAnswersData} 
                        getAllComplains={this.state.allComplains}
                        getComplainData={this.state.complainData} 
                        getComplainLocationData={this.state.complainLocationData} 
                        surgeon_id={this.state.surgeon_id}
                        setAllComplains={this.setAllComplains}
                        setNarrativeSummary={this.setNarrativeSummary}
                       



                    />
                }
               {/* { console.log('this.state.next on master',this.state.next) } */}
                
                {this.state.next === 5 && 
                    <PatientNarrative 
                        setNarrativeSummary={this.setNarrativeSummary}
                        setAllComplains={this.setAllComplains}
                        getAllComplains={this.state.allComplains}
                        getProfileData={this.state.profileData} 
                        handleNextPrevSteps={this.handleNextPrevSteps} 
                        getComplainData={this.state.complainData} 
                        getComplainLocationData={this.state.complainLocationData} 
                        setQuestionAnswersData={this.setQuestionAnswersData} 
                        setCheckedItems={this.setCheckedItems} 
                        getQuestionAnswersData={this.state.questionAnswersData} 
                        isNarrativeUpdate={this.state.isNarrativeUpdate} 
                        setIsNarrativeUpdate={this.setIsNarrativeUpdate}
                        surgeon_id={this.state.surgeon_id}
                        setSelectedComplains={this.setSelectedComplains}
                        addAnotherComplain={this.addAnotherComplain}
                        setIsModify={this.setIsModify}
                        isModify={this.state.isModify}
                        checkedItems={this.state.checkedItems}
                        narrativeData={this.state.narrativeData}


                    />
                }
                {this.state.next === 6 && 
                    <PatientResponse 
                        getNarrativeSummary={this.state.narrativeSummary}
                        getAllComplains={this.state.allComplains}
                        getProfileData={this.state.profileData} 
                        handleNextPrevSteps={this.handleNextPrevSteps} 
                        setResponseData={this.state.setResponseData} 
                        getComplainData={this.state.complainData} 
                        getComplainLocationData={this.state.complainLocationData}
                        isNarrativeUpdate={this.state.isNarrativeUpdate}
                        setSelectedComplains={this.setSelectedComplains}
                        setIsModify={this.setIsModify}
                        surgeon_id={this.state.surgeon_id}
                        
                    />
                }
            </React.Fragment>
        );
    }

    handleNextPrevSteps = (nextStep)=>
    {   
        this.setState({
            next:nextStep,
            prev:nextStep-1,
        });
    }
    addAnotherComplain=(isTrue)=>
    {
        this.setState({
            addAnotherComplain:isTrue
        })
    }
    setProfileData=(data)=>{
        this.setState({
            profileData:data
        });
    }
    setSelectedComplains = (id)=>{
        let _selectedComplains = this.state.selectedComplains;

        if(!_selectedComplains.includes(id)){
            _selectedComplains.push(parseInt(id));
            this.setState({
                selectedComplains:_selectedComplains
            })

        }
    }
    setComplainData=(data)=>{
        this.setState({
            complainData:data
        });
    }
    setNarrativeSummary=(narrativeSummary)=>{
        let profileData = this.state.profileData;
        profileData['narrative_summary'] = narrativeSummary;
        this.setState({
            profileData:profileData,
            //profileData:profileData
        });
        
    }

    setAllComplains=(complain_prop)=>{

        // console.log("Passed Complain Props");
        // console.log(complain_prop);
        // console.log('Master current state allComplains',this.state.allComplains);
        let foundtwo = false;
        if(localStorage.getItem("data"))
        { 
            var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("data"));
            let data=JSON.parse(decryptedData); 
            // console.log('local data in master',data) 
            if(this.state.allComplains.length > 0){
                Object.values(data).forEach((item,key)=>{

                    if(parseInt(this.state.complainData.complain_types) === parseInt(item.complain_type)){
                        // console.log('in 1st if')
                        
                            for(var i = 0; i < this.state.allComplains.length; i++){
                                if(this.state.allComplains[i].image_and_points[this.state.allComplains[i].image_and_points.length-1].complain_type == this.state.complainData.complain_types)
                                {   
                                    // console.log('in 2nd if')
                                    let updatedkey = complain_prop.image_and_points[key];
                                    // console.log('updatedkey data before',updatedkey)
                                    complain_prop.image_and_points = [];
                                    complain_prop.image_and_points[0] = updatedkey;
                                    // console.log('updatedkey is there index',updatedkey)

                                    this.state.allComplains[i]=complain_prop;
                                    foundtwo =false;
                                    break;
                                }else{
                                    // console.log('in 2nd else')
                                    foundtwo =true;
                                }
                            }
                            if (foundtwo) {
                                foundtwo =false;
                                // console.log('foundtwo check')
                                this.setState({
                                    allComplains:[...this.state.allComplains,complain_prop],
                                    //profileData:profileData
                                });
                            }
                        
                    }

                });
            }
            else{
                // console.log('In last else')
                this.setState({
                    allComplains:[...this.state.allComplains,complain_prop],
                    //profileData:profileData
                });
            }
            if (this.state.allComplains.length > 0) {
                var myComplains = this.state.allComplains;
                myComplains[myComplains.length-1].profileSummary = complain_prop.profileSummary;
            
            }
            
        }
        
        let found = false;
        // let foundIndex;
        // let foundIndexprops;
        // for(var i = 0; i < this.state.allComplains.length; i++) {
        //     for (let index = 0; index < complain_prop.image_and_points.length; index++) {
        //         if (this.state.allComplains[i].image_and_points[this.state.allComplains[i].image_and_points.length-1].complain_type === complain_prop.image_and_points[index].complain_type) {
        //             console.log('Matched complain', this.state.allComplains[i])
        //             found = true;
        //             foundIndex=i;
        //             foundIndexprops = index;
        //             this.state.allComplains[i].image_and_points[this.state.allComplains[i].image_and_points.length-1]=complain_prop.image_and_points[index];
        //             break;
        //         }
                
        //     }
            
        // }

        if(found){
        //    Map
            // let filteredArray = this.state.allComplains.map((item,key)=>{

            //     if(key===foundIndex){

            //         return complain_prop;
            //     }else{
            //         return item;
            //     }

            // });

            // this.setState({
            //     allComplains:filteredArray,
            //     //profileData:profileData
            // });

        }else{

            // this.setState({
            //     allComplains:[...this.state.allComplains,complain_prop],
            //     //profileData:profileData
            // });
        }

        // console.log('Master state after setting allComplains',this.state.allComplains);


    }

    setComplainLocationData=(data)=>{
        this.setState({
            complainLocationData:data
        });
    }

    setQuestionAnswersData=(data)=>{
        this.setState({
            questionAnswersData:data
        });
    }
    
    setResponseData=(data)=>{
        this.setState({
            responseData:data
        });
    }

    setIsNarrativeUpdate = (data) =>{
        this.setState({
            isNarrativeUpdate:data
        });
    }
    
    setCheckedItems = (checkedItems) =>{
        this.setState({ checkedItems: checkedItems});
    }

    setOptionInputFields = (data) =>{
        this.setState({
            optionInputFields:data
        });
    }

    setShowInputField = (data) =>{
        this.setState({
            showInput:data
        });
    }

}
export default Master;